import { render } from "./RolesManagement.vue?vue&type=template&id=1c16c312&scoped=true"
import script from "./RolesManagement.vue?vue&type=script&lang=js"
export * from "./RolesManagement.vue?vue&type=script&lang=js"

import "./RolesManagement.vue?vue&type=style&index=0&id=1c16c312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c16c312"]])

export default __exports__